<template>
  <d-data-table
    fluid
    resource="owner-contacts"
    :show-button="false"
    :url="$laravel.route(`api.owner-contacts.index`, owner_id)"
    searchable
    :edit-url="(row) => `/owners/${owner_id}/contacts/${row.id}/edit`"
    no-padding
  >
    <b-table-column
      v-slot="props"
      field="name"
      :label="$t('name').capitalize()"
      sortable
    >
      <div class="is-size-7">
        <router-link :to="`contacts/${props.row.id}`">
          {{ props.row.name }}
        </router-link>
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="email"
      :label="$t('email').capitalize()"
      sortable
    >
      <div class="is-size-7">
        {{ props.row.email }}
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="is_admin_contact"
      :label="$t('is_admin_contact').capitalize()"
      sortable
    >
      <div class="is-size-7">
        <d-bool-icon
          :true-value="true"
          :false-value="false"
          :value="props.row.is_admin_contact"
        />
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="phone"
      :label="$t('phone').capitalize()"
      sortable
    >
      <div class="is-size-7">
        {{ props.row.phone }}
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="assigned_task"
      :label="$t('assigned_task').capitalize()"
      sortable
    >
      <div class="is-size-7">
        {{ props.row.assigned_task }}
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="role"
      :label="$t('role').capitalize()"
      sortable
    >
      <div class="is-size-7">
        {{ props.row.role }}
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="birthday"
      :label="$t('birthday').capitalize()"
      sortable
    >
      <div class="is-size-7">
        {{ props.row.birthday }}
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="created_at"
      sortable
      :label="$t('attributes.created_at').capitalize()"
    >
      <div class="is-size-7">
        {{ $dayjs(props.row.created_at).format("LLL") }}
      </div>
    </b-table-column>
  </d-data-table>
</template>

<script>
export default {
  props: {
    owner_id: {
      required: true,
      type: Number,
    },
  },
};
</script>
